export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CART_UPDATED = "CART_UPDATED";
export const CLEAR_CART = "CLEAR_CART";
export const GET_CART = "GET_CART";